module.exports = __webpack_public_path__ + "static/media/checkbox-inactive.15008e49.svg";